/**
 * @file        src/lib/domInt.js
 * @description The Domestic / International scope a pricing rule can carry —
 *              flight and hotel Convenience Fee, Discount, Coupon and the Hotel
 *              Markup (admin migration 076), the field Flight Markup has had
 *              since 017. One option list and one label, so every screen names
 *              the three choices the same way.
 *
 *              Stored as NULL ("All") / 'domestic' / 'international'. Domestic
 *              means within India; a flight is international when any part of
 *              it is outside India, a hotel when the property is.
 * @author      Kinetika Labs
 * @created     2026-10-06
 * @changelog
 *   - 2026-10-06 Claude — Initial.
 */

/** What a blank (NULL) scope means, wherever it is shown. */
export const DOM_INT_ALL_LABEL = 'All (Domestic + International)';

/** The two real choices; blank = All, rendered by the select's empty option. */
export const DOM_INT_OPTIONS = [
  { value: 'domestic', label: 'Domestic' },
  { value: 'international', label: 'International' },
];

/** For a custom form's <Select>: All first, as an explicit choice. */
export const DOM_INT_SELECT_OPTIONS = [{ value: '', label: DOM_INT_ALL_LABEL }, ...DOM_INT_OPTIONS];

/** Table-cell label for a stored value. */
export function domIntLabel(v) {
  return DOM_INT_OPTIONS.find((o) => o.value === v)?.label || 'All';
}

/**
 * The SimpleLookupPage field. `nullable` so choosing All on edit really clears
 * a stored scope; `blankLabel` so the empty choice and the table cell both say
 * "All" rather than a bare dash.
 */
export function domIntField() {
  return {
    key: 'dom_int',
    label: 'Domestic / International',
    type: 'select',
    options: DOM_INT_OPTIONS,
    nullable: true,
    blankLabel: DOM_INT_ALL_LABEL,
  };
}
